import React from 'react';
import ScrollAnimation from './ScrollAnimation';

const BusinessManagement = () => {
  const managementFeatures = [
    {
      id: 1,
      title: 'إدارة مخزون فوري',
      description: 'راقب مخزونك في الوقت الفعلي مع تحديثات فورية عند كل عملية بيع أو شراء. احصل على تنبيهات تلقائية عند نفاد المنتجات، وتتبع حركة المخزون بدقة عالية. نظام متكامل يربط بين جميع فروعك لإدارة موحدة.',
      image: '/images/inventory_managment.png',
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
        </svg>
      )
    },
    {
      id: 2,
      title: 'كسب ثقة العملاء',
      description: 'بناء علاقات قوية مع عملائك من خلال برامج الولاء المخصصة، تتبع تفضيلاتهم، وتقديم عروض مخصصة. نظام نقاط ومكافآت يجعل عملائك يعودون دائماً. إدارة شاملة لبيانات العملاء تساعدك على تقديم تجربة استثنائية.',
      image: '/images/loyality.png',
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
        </svg>
      )
    },
    {
      id: 3,
      title: 'إدارة المبيعات',
      description: 'نظام نقاط بيع متكامل وسهل الاستخدام يتيح لك إدارة المبيعات بكفاءة عالية. تتبع المبيعات اليومية والأسبوعية والشهرية، واحصل على تقارير مفصلة عن أداء منتجاتك. واجهة بديهية تسرع عملية البيع وتقلل الأخطاء.',
      image: '/images/pos.png',
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
        </svg>
      )
    },
    {
      id: 4,
      title: 'إدارة المالية',
      description: 'راقب وضعك المالي بدقة مع تقارير مالية شاملة وتفصيلية. تتبع الإيرادات والمصروفات، واحصل على تحليلات مالية متقدمة تساعدك على اتخاذ قرارات مدروسة. نظام محاسبة متكامل يبقيك على اطلاع دائم بصحة أعمالك المالية.',
      image: '/images/fin.png',
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
        </svg>
      )
    }
  ];

  return (
    <section className="py-24 bg-white relative overflow-hidden" id="management">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-primary-500 font-bold tracking-wider uppercase text-sm mb-2 block">
            إدارة شاملة
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            كل ما تحتاجه لإدارة <span className="text-primary-500">عملك بكفاءة</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            نظام متكامل يجمع بين إدارة المخزون والمبيعات والمالية وعلاقات العملاء في منصة واحدة
          </p>
        </div>

        {/* Features List */}
        <div className="space-y-24 md:space-y-32">
          {managementFeatures.map((feature, index) => (
            <ScrollAnimation key={feature.id} variant="fade-up" delay={index * 100}>
              <div className={`flex flex-col ${index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'} items-center gap-8 md:gap-12`}>
                {/* Image Section */}
                <div className="w-full md:w-1/2 flex-shrink-0">
                  <div className="relative rounded-2xl overflow-hidden   group">
                    <img 
                      src={feature.image} 
                      alt={feature.title}
                      className="w-full h-auto object-cover transform group-hover:scale-105 transition-transform duration-700"
                    />
                    {/* Overlay gradient */}
                    <div className="absolute inset-0  opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                  </div>
                </div>

                {/* Content Section */}
                <div className="w-full md:w-1/2 flex flex-col justify-center">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="bg-primary-500/10 text-primary-500 p-3 rounded-xl">
                      {feature.icon}
                    </div>
                    <h3 className="text-2xl md:text-3xl font-bold text-gray-900">
                      {feature.title}
                    </h3>
                  </div>
                  <p className="text-lg text-gray-600 leading-relaxed">
                    {feature.description}
                  </p>
                  
                  {/* Decorative line */}
                  <div className="mt-6 w-20 h-1 bg-primary-500 rounded-full"></div>
                </div>
              </div>
            </ScrollAnimation>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BusinessManagement;
